import {
  CreateButton,
  DeleteButton,
  EditButton,
  ExportButton,
  getDefaultSortOrder,
  List,
  ShowButton,
  TextField,
  useTable,
} from "@refinedev/antd";

import { Divider, Space, Table, Tag } from "antd";
import type { ColumnsType } from "antd/es/table";
import { IResourceComponentsProps, useExport } from "@refinedev/core";
import { ICountry } from "interfaces";
import React from "react";

export const CountryList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, sorters, tableQuery: { isLoading } } = useTable<ICountry>({
    sorters: {
      initial: [
        {
          field: "id",
          order: "asc",
        },
      ]
    }
  });

  const { triggerExport, isLoading: isLoadingExport } = useExport<ICountry>({
    mapData: (item) => {
      return {
        "Country Name": item?.name || "",
        "ISO Country Code": item?.isoCode || "",
        "ISO3 Country Code": item?.iso3Code || "",
      };
    },
    unparseConfig: {
      header: true,
      columns: ["Country Name", "ISO Country Code", "ISO3 Country Code"],
    },
  });

  const columns: ColumnsType<ICountry> = [
    {
      title: "Country Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      className: "wrap-text",
      render: (value) => <TextField value={value} />,
      defaultSortOrder: getDefaultSortOrder("name", sorters),
      sorter: true,
    },
    {
      title: "ISO Country Code",
      dataIndex: "isoCode",
      key: "isoCode",
      width: 150,
      render: (value) => <TextField value={value} />,
      defaultSortOrder: getDefaultSortOrder("isoCode", sorters),
      sorter: true,
    },
    {
      title: "ISO3 Country Code",
      dataIndex: "iso3Code",
      key: "iso3Code",
      width: 150,
      render: (value) => <TextField value={value} />,
      defaultSortOrder: getDefaultSortOrder("iso3Code", sorters),
      sorter: true,
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 120,
      render: (_, record) => (
        <Space>
          <EditButton hideText size="small" recordItemId={record.id} />
          <ShowButton hideText size="small" recordItemId={record.id} />
          <DeleteButton hideText size="small" recordItemId={record.id} />
        </Space>
      ),
    },
  ];

  return (
    <List
      breadcrumb={false}
      headerProps={{
        // onBack: () => window.history.back(),
        subTitle: "active countries",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
        extra: (
          <React.Fragment>
            <Space>
              <CreateButton />
              <ExportButton onClick={triggerExport} loading={isLoadingExport} />
            </Space>
          </React.Fragment>
        ),
        ghost: true,
        footer: (
          <Divider plain>
            © {new Date().getFullYear()} e-Mariner NavSolutions
          </Divider>
        ),
      }}
    >
      <Table
        {...tableProps}
        columns={columns}
        rowKey="id"
        size="middle"
        scroll={{ x: 1200 }}
        sticky
        pagination={{
          ...tableProps.pagination,
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
        }}
      />
    </List>
  );
};
